import { render } from "./postpartumCare.vue?vue&type=template&id=8eb53a02"
import script from "./postpartumCare.vue?vue&type=script&lang=js"
export * from "./postpartumCare.vue?vue&type=script&lang=js"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__